import Vue from "vue";
import Vuex from "vuex";
import axios from "axios";
import moment from "moment";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    showPage: false,
    totalProject: 3,
    projectCount: 0,
    payments: {
      // revotax: {
      //   today: {
      //     success: [],
      //     failed: [],
      //   },
      //   yesterday: {
      //     success: [],
      //     failed: [],
      //   },
      //   this_week: {
      //     success: [310, 400, 280, 510, 420, 109, 0],
      //     failed: [200, 100, 180, 210, 520, 119, 0],
      //   },
      //   last_week: {
      //     success: [210, 300, 180, 510, 620, 209, 200],
      //     failed: [205, 110, 108, 220, 120, 109, 0],
      //   },
      //   this_month: {
      //     success: [
      //       492,
      //       721,
      //       676,
      //       768,
      //       529,
      //       646,
      //       432,
      //       579,
      //       553,
      //       783,
      //       410,
      //       584,
      //       401,
      //       721,
      //       603,
      //       665,
      //       576,
      //       726,
      //       492,
      //       587,
      //       793,
      //     ],
      //     failed: [
      //       405,
      //       691,
      //       725,
      //       478,
      //       501,
      //       732,
      //       548,
      //       472,
      //       732,
      //       707,
      //       537,
      //       493,
      //       589,
      //       706,
      //       699,
      //       401,
      //       414,
      //       553,
      //       738,
      //       789,
      //       780,
      //     ],
      //   },
      //   this_year: {
      //     success: [
      //       10967,
      //       4576,
      //       17248,
      //       11251,
      //       4540,
      //       16117,
      //       17547,
      //       14012,
      //       16811,
      //       19299,
      //       0,
      //       0,
      //     ],
      //     failed: [
      //       5941,
      //       15202,
      //       10125,
      //       19128,
      //       13528,
      //       10828,
      //       17198,
      //       14909,
      //       4167,
      //       13035,
      //       0,
      //       0,
      //     ],
      //   },
      //   total_amount: {
      //     success: 375004.8,
      //     failed: 124004.8,
      //   },
      //   total_count: {
      //     success: 376,
      //     failed: 12,
      //   },
      //   total_amount_year: 375004.8,
      //   total_count_year: 3750,
      //   group_transaction_count: {
      //     success: {
      //       count: [],
      //       labels: [],
      //     },
      //     failed: {
      //       count: [],
      //       labels: [],
      //     },
      //   },
      // },
    },
    marqueeData: {
      // {
      //   name: "Nibs Salary",
      //   amount: 34000,
      //   status: 1,
      // },
    },
    projectColors: [
      {
        title: "#191932",
        bg: "#e6f2ff",
        bg_line: "#e6f2ff",
        bg_text: "#191932",
      },
      {
        title: "#e6f2ff",
        bg: "#05050F",
        bg_line: "#191932",
        bg_text: "#ffffff",
      },
      {
        title: "#191932",
        bg: "#e6f2ff",
        bg_line: "#e6f2ff",
        bg_text: "#191932",
      },
      {
        title: "#e6f2ff",
        bg: "#05050F",
        bg_line: "#191932",
        bg_text: "#ffffff",
      },
      {
        title: "#191932",
        bg: "#e6f2ff",
        bg_line: "#e6f2ff",
        bg_text: "#191932",
      },
    ],
  },

  getters: {
    paymentEmpty: (state) => {
      return Object.keys(state.payments).length <= 0 ? true : false;
    },
    showPage: (state) => {
      return state.projectCount >= state.totalProject;
    },
    allprojects: (state) => {
      return Object.keys(state.payments);
    },
    projectPayments: (state) => (projectName) => {
      return state.payments[projectName];
    },
    marqueeData: (state) => {
      return state.marqueeData;
    },
    projectColors: (state) => (i) => {
      return state.projectColors[i] || state.projectColors[0];
    },
  },

  mutations: {
    addToMarquee(state, payload) {
      state.marqueeData.push(payload);
    },
  },

  actions: {
    async getPayment({ commit, state }) {
      // try {
      //   const veripay_url = "https://veripay.ng/dashboardstream/index.php";
      //   const veripayResult = await axios.get(veripay_url);
      //   state.payments.veripay = veripayResult.data;
      //   state.marqueeData.veripay_success = {
      //     name: "Veripay Success today",
      //     amount: Number(
      //       veripayResult.data.total_amount.success
      //     ).toLocaleString(),
      //     status: 1,
      //   };
      //   state.marqueeData.veripay_inprogress = {
      //     name: "Veripay Inprogress today",
      //     amount: Number(
      //       veripayResult.data.total_amount.inprogress
      //     ).toLocaleString(),
      //     status: 0,
      //   };
      //   state.marqueeData.veripay_failed = {
      //     name: "Veripay failed today",
      //     amount: Number(
      //       veripayResult.data.total_amount.failed
      //     ).toLocaleString(),
      //     status: 0,
      //   };
      // } catch (err) {
      //   console.log(err);
      // }

      try {
        const anambraRev_url = "https://asibs.online/ApiPayment/dashReport";
        const anambraRevresult = await axios.post(anambraRev_url);
        state.payments.anambra_revotax = anambraRevresult.data;
        state.marqueeData.anambra_revotax_success = {
          name: "Anambra Revotax Success today",
          amount: Number(
            anambraRevresult.data.total_amount.success
          ).toLocaleString(),
          status: 1,
        };
        state.marqueeData.anambra_revotax_failed = {
          name: "Anambra Revotax failed today",
          amount: Number(
            anambraRevresult.data.total_amount.failed
          ).toLocaleString(),
          status: 0,
        };
        state.projectCount += 1;
      } catch (err) {
        console.log(err);
      }

      try {
        const crsRev_url = "https://crs.revotax.com/ApiPayment/dashReport";
        const crsRevresult = await axios.post(crsRev_url);
        state.payments.crs_revotax = crsRevresult.data;
        state.marqueeData.crs_revotax_success = {
          name: "CRS Revotax Success today",
          amount: Number(
            crsRevresult.data.total_amount.success
          ).toLocaleString(),
          status: 1,
        };
        state.marqueeData.crs_revotax_failed = {
          name: "CRS Revotax failed today",
          amount: crsRevresult.data.total_amount.failed,
          status: 0,
        };
        state.projectCount += 1;
      } catch (err) {
        console.log(err);
      }

      try {
        const imoRev_url = "https://imostate.tax/app/ApiPayment/dashReport";
        const imoRevresult = await axios.post(imoRev_url);
        state.payments.imo_revotax = imoRevresult.data;
        state.marqueeData.imo_revotax_success = {
          name: "Imo Revotax Success today",
          amount: Number(
            imoRevresult.data.total_amount.success
          ).toLocaleString(),
          status: 1,
        };
        state.marqueeData.imo_revotax_failed = {
          name: "Imo Revotax failed today",
          amount: imoRevresult.data.total_amount.failed,
          status: 0,
        };
        state.projectCount += 1;
      } catch (err) {
        console.log(err);
      }

      try {
        // const abiaRev_url = "https://abia.tax/app/ApiPayment/dashReport";
        // const abiaRevresult = await axios.post(abiaRev_url);
        // state.payments.abia_revotax = abiaRevresult.data;
        // state.marqueeData.abia_revotax = {
        //   name: "Abia Revotax Success today",
        //   amount: Number(
        //     abiaRevresult.data.total_amount.success
        //   ).toLocaleString(),
        //   status: 1,
        // });
        // state.marqueeData.abia_revotax = {
        //   name: "Abia Revotax failed today",
        //   amount: abiaRevresult.data.total_amount.failed,
        //   status: 0,
        // });
        // state.projectCount += 1;
      } catch (err) {
        console.log(err);
      }
    },

    makeDummyData({ commit, state }, { start, end, day }) {
      let ses = [];

      function randomIntFromInterval(min, max) {
        // min and max included
        return Math.floor(Math.random() * (max - min + 1) + min);
      }

      for (let i = 0; i < 20; i++) {
        ses.push([
          randomIntFromInterval(start, end),
          randomIntFromInterval(2000, 50000),
        ]);
      }

      ses.sort((a, b) => (a[0] > b[0] ? 1 : -1));

      state.payments.revotax[day].success = ses;
      state.payments.veripay[day].success = ses;
    },
  },

  modules: {},
});
